import React from "react";
import { shape, func, bool, string } from "prop-types";
import { Link } from "@quintype/components";

const MenuItem = ({ item }) => {
  if (item["item-type"] === "placeholder") {
    return <span>{item.title}</span>;
  } else if (item["item-type"] === "link") {
    return (
      <a href={item.completeUrl} rel="noopener noreferrer">
        {item.title}
      </a>
    );
  } else {
    return (
      <Link href={item.completeUrl} rel="noopener noreferrer">
        {item.title}
      </Link>
    );
  }
};

MenuItem.propTypes = {
  item: shape({
    isExternalLink: bool,
    completeUrl: string,
    title: string,
  }),
  itemClick: func,
};

export { MenuItem };
